// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-hotel-to-booking-action{margin:0;font-weight:var(--font-weight-medium)}.h-hotel-to-booking-action .h-btn__stack-main{font-size:14px;line-height:1}.h-hotel-to-booking-action .h-btn__stack-sub{font-size:10px;line-height:1}@media (min-width:768px){.h-hotel-to-booking-action{min-width:120px;height:52px;margin-left:auto}}@media (max-width:767px){.h-hotel-to-booking-action{margin-left:auto;-webkit-box-shadow:none;box-shadow:none}}", ""]);
// Exports
module.exports = exports;
